export default {
  projectName: "ticketverse",
  isRTL: true,
  dark: false,
  // Vuetify theme colors (also exposed as --v-<name>-base CSS variables, used by src/styles/main.scss).
  // Every color that carries white text keeps at least a 4.5:1 contrast ratio.
  colors: {
    primary: "#187DA0", // brand teal-blue
    secondary: "#4F6D7A", // slate
    accent: "#5E9E2F", // brand green
    error: "#C8363F", // red
    info: "#1F6FB2", // blue
    success: "#18804A", // green
    warning: "#A35F00", // amber
    darkBackground: "#121A21",
    lightBackground: "#F3F6F9"
  },
  backType: 'gradient',
  image: null,
  appbar: "light",
  drawer: "dark"
};
